import React from "react";
import "./FranchiseMapSection.css";

const FranchiseMapSection = () => {
  return (
    <section className="franchise-section">
      <div className="franchise-container">

        <h2 className="franchise-title">
          For <span>Franchise Enquiry</span>, Click Here
        </h2>

        <div className="title-underline"></div>

        <div className="map-card">
          <iframe
  title="NIECCE Location Highlighted"
  width="100%"
  height="100%"
  style={{ border: 0 }}
  loading="lazy"
  allowFullScreen=""
  referrerPolicy="no-referrer-when-downgrade"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.432458833091!2d77.50680321482107!3d12.959149317375261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3f30087bbd81%3A0xce2c3453e52d8473!2sNIECCE%20Teacher%20Training%20Institute!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
></iframe>

        </div>

      </div>
    </section>
  );
};

export default FranchiseMapSection;
